import { useBaseAppDevStore } from "../stores";
import { errorMsg, msgData } from "./utils";

export const getAppVariable = (data) => {
  try {
    const { key } = data;
    const value = useBaseAppDevStore.getState().getVariable(key);
    return msgData(data, {
      value
    });
  } catch (e) {
    return errorMsg(data, e);
  }
};

export const setAppVariable = (data) => {
  try {
    const { key, value } = data;
    let resp;
    if (typeof key === "string") {
      resp = useBaseAppDevStore.getState().updateVariables({ [key]: value });
    } else if (typeof key === "object") {
      resp = useBaseAppDevStore.getState().updateVariables(key);
    }
    return msgData(data, {
      ...resp
    });
  } catch (e) {
    return errorMsg(data, e);
  }
};
